import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import { sharedInputStyles } from "./styles";
import { css } from "@emotion/react";
import { FONTS } from "../../../../styles/fonts";
import React from "react";
import { FormElementWrapper } from "./FormElementWrapper";
import { FormDefinitionLongText } from "./from-definition";
import { FormIcon } from "./FormIcon";

export const TextAreaWithCharacterLimit: ReactTFC<{
  formField: FormDefinitionLongText;
  value: string;
  setValue: (v: string) => void;
}> = props => {
  const limitStr = `${props.value.length}/${props.formField.charactersLimit}`;

  return (
    <FormElementWrapper height={props.formField.height}>
      <FormIcon iconAlignment={props.formField.iconAlignment} Icon={props.formField.Icon} />

      <textarea
        value={props.value}
        onChange={e => {
          const v = e.target.value;

          if (v.length <= props.formField.charactersLimit) {
            props.setValue(v);
          }
        }}
        css={[
          sharedInputStyles,
          css`
            resize: none;

            padding-right: 85px;
          `,
        ]}
        placeholder={props.formField.placeholder}
      />
      {limitStr && (
        <span
          css={css`
            position: absolute;
            right: 20px;
            top: 22px;

            ${FONTS.SwarovskiFutura300}
          `}
        >
          {limitStr}
        </span>
      )}
    </FormElementWrapper>
  );
};
